import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutation'

Vue.use(Vuex)

const state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  historyPage: '',
  currentPath: '',
  order_data: {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  },
  item_subs: [],
  branch_list: null
}

const store = new Vuex.Store({
  mutations,
  state
})

export default store



// WEBPACK FOOTER //
// ./src/Vuex/store.js